/**
 * Runtime entry point.
 *
 * Exports a singleton SandboxRuntime instance that communicates
 * with K8s sandbox pods via the server's SandboxModule.
 */

import { SandboxRuntime } from './sandbox-runtime';

interface RuntimeContext {
  loaded: boolean;
}

export const runtimeContext: RuntimeContext = import.meta.hot?.data.runtimeContext ?? {
  loaded: false,
};

if (import.meta.hot) {
  import.meta.hot.data.runtimeContext = runtimeContext;
}

// Create a singleton SandboxRuntime instance
const runtimeInstance: SandboxRuntime = import.meta.hot?.data.runtime ?? new SandboxRuntime();

if (import.meta.hot) {
  import.meta.hot.data.runtime = runtimeInstance;
}

export const runtime = runtimeInstance;

// Promise-wrapped export for stores that do `await runtimePromise`
export const runtimePromise: Promise<SandboxRuntime> = Promise.resolve(runtimeInstance);
